import apiClient from "./client";

export const authApi = {
  /**
   * 1. Register new user account
   */
  signup: async (payload) => {
    const response = await apiClient.post("/auth/signup", payload);
    return response.data;
  },

  /**
   * 2. Verify email address via token
   */
  verifyEmail: async ({ token }) => {
    const response = await apiClient.post("/auth/verify-email", { token });
    return response.data;
  },

  /**
   * 3. Authenticate user credentials
   */
  login: async ({ email, password }) => {
    const response = await apiClient.post("/auth/login", { email, password });
    return response.data;
  },

  /**
   * 4. Refresh access token
   */
  refresh: async ({ refreshToken }) => {
    const response = await apiClient.post("/auth/refresh", { refreshToken });
    return response.data;
  },

  /**
   * 5. Logout current session
   */
  logout: async () => {
    const response = await apiClient.post("/auth/logout");
    return response.data;
  },

  /**
   * 6. Revoke all active sessions across devices
   */
  revokeAllSessions: async () => {
    const response = await apiClient.post("/auth/revoke-all-sessions");
    return response.data;
  },

  /**
   * 7. Request password reset email
   */
  forgotPassword: async ({ email }) => {
    const response = await apiClient.post("/auth/forgot-password", { email });
    return response.data;
  },

  /**
   * 8. Reset password using email token
   */
  resetPassword: async ({ token, newPassword }) => {
    const response = await apiClient.post("/auth/reset-password", {
      token,
      newPassword,
    });
    return response.data;
  },

  /**
   * 9. Get current authenticated user profile
   */
  getMe: async () => {
    const response = await apiClient.get("/auth/me");
    return response.data;
  },

  /**
   * 10. Get extended user profile from /users/profile
   */
  getProfile: async () => {
    const response = await apiClient.get("/users/profile");
    return response.data;
  },

  /**
   * 11. Update user profile fields (avatar, age, profession, dietary, location, etc.)
   */
  updateProfile: async (payload) => {
    const response = await apiClient.patch("/users/profile", payload);
    return response.data;
  },

  /**
   * 12. Authenticate or register with LinkedIn OAuth 2.0
   */
  loginWithLinkedIn: async ({ code, redirect_uri }) => {
    const response = await apiClient.post("/auth/linkedin", { code, redirect_uri });
    return response.data;
  },
};

export default authApi;

